import React from "react";
import { observer, inject } from "mobx-react";
import { pipe } from "Utils/functionalUtils";

const ReviewsSendHOC = (props) => {
	const {
		ApplicationModel: { modalModel, text },
	} = props;
	const openPopup = (data) => {
		closeModal();
		let promise1 = import("Layouts/modalLayout");
		let promise2 = import("ComponentsUI/Sended/SendedReview");
		Promise.all([promise1, promise2]).then((modules) => {
			let ModalLayout = modules[0].default;
			let SendedReview = modules[1].default;
			modalModel.toggleModal(
				<ModalLayout authView={true} withoutClose={true}>
					<SendedReview closeModal={closeModal} text={text} />
				</ModalLayout>
			);
		});
	};

	const closeModal = () => {
		modalModel.toggleModal();
	};

	return React.cloneElement(props.children, {
		openPopup: (data) => openPopup(data),
	});
};

export default pipe(observer, inject("ApplicationModel"))(ReviewsSendHOC);
